import api from '@/apis/di/accountAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance } from 'vue';
import { MSConstant } from '@/commons/wildcards';

// Combo grid Tài khoản chi phí
export const useAccountCostComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { proxy } = getCurrentInstance();
  const { extendFilter } = usefilterActionCombo();

  // func call api lấy dữ liệu combo
  const onAccountCostComboboxLoadData = (payload, row, column) => {
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];
    // orsLike bao gồm các đầu tài khoản hiển thị lên combo
    let orsLike = [
      {
        Field: 'account_number',
        Operator: MSConstant.FilterOperator.StartsWith,
        Value: '612',
      },
      {
        Field: 'account_number',
        Operator: MSConstant.FilterOperator.StartsWith,
        Value: '614',
      },
      {
        Field: 'account_number',
        Operator: MSConstant.FilterOperator.StartsWith,
        Value: '632',
      },
      {
        Field: 'account_number',
        Operator: MSConstant.FilterOperator.StartsWith,
        Value: '642',
      },
      {
        Field: 'account_number',
        Operator: MSConstant.FilterOperator.StartsWith,
        Value: '652',
      },
      {
        Field: 'account_number',
        Operator: MSConstant.FilterOperator.StartsWith,
        Value: '811',
      },
    ];
    let orsIsParent = [{ Field: 'is_parent', Operator: 'NULL' }];
    let extend = [
      { Field: 'inactive', Value: false, Ors: ors },
      {
        Field: 'account_number',
        Operator: MSConstant.FilterOperator.StartsWith,
        Value: '611',
        Ors: orsLike,
      },
      { Field: 'is_parent', Value: false, Ors: orsIsParent },
    ];
    payload.filter = extendFilter(payload.filter, extend);
    payload.sort = 'account_number';
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
  };

  // config columns combo
  const accountCostComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Số tài khoản',
        dataField: 'account_number',
        width: 120,
        filterOperator: MSConstant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên tài khoản',
        dataField: 'account_name',
        filterOperator: MSConstant.FilterOperator.Contains,
        width: 480,
      },
    ],
    displayField: 'account_number',
    valueField: 'account_number',
    queryMode: 'remote',
    dropdownWidth: 600,
    comboboxLoadData: onAccountCostComboboxLoadData,
  };

  return {
    accountCostComboConfig,
    onAccountCostComboboxLoadData, // trả về thêm để dùng chung cho cả combo không thuộc grid
  };
};
